import { RouteType } from '../../../types/RouteType'
import { InvoiceConversionViewStore } from './stores/InvoiceConversionViewStore'
import { RootStore } from '@intrasync/stores'

const InvoiceConversionRoute: RouteType = {
  name: 'Invoice To PO',
  path: '/accounting/invoice-conversion',
  layout: '/app',
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  group: 'Accounting',

  viewportCard: {
    header: {
      component: () => import('./components/InvoiceConversionHeader'),
      title: 'Invoice to Purchase Order',
      color: 'primary',
      enableRefreshButton: false,
      enableBackButton: true
    },
    body: {
      component: () => import('./components/InvoiceConversionWizard'),
      grayBackground: true
    }
  },

  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    // Load required data
    try {
      // Load invoices (vendor invoices that can be converted)
      await (rootStore as any).invoicesStore.find({
        query: {
          status: { $in: ['draft', 'sent'] },
          purchaseOrderId: null // Not already linked to a PO
        }
      })

      // Load suppliers/vendors
      if ((rootStore as any).suppliersStore) {
        await (rootStore as any).suppliersStore.find({})
      }

      // Load accounts (suppliers may be in accounts)
      if ((rootStore as any).customersStore) {
        await (rootStore as any).customersStore.find({})
      }

      // Load users for approvers
      if ((rootStore as any).userStore) {
        await (rootStore as any).userStore.find({})
      }

      // Load jobs if needed
      if ((rootStore as any).jobStore) {
        await (rootStore as any).jobStore.find({})
      }
    } catch (error) {
      // Error loading data for invoice conversion
    }

    return true
  },

  beforeExit: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).invoiceConversionViewStore as InvoiceConversionViewStore

    // Don't prompt if conversion was successful
    if (store.conversionSuccess) {
      return true
    }

    // Auto-save draft if there are unsaved changes
    if (store.isDirty && store.selectedInvoiceId) {
      await store.saveDraft()
    }
    return true
  },

  onExit: ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).invoiceConversionViewStore as InvoiceConversionViewStore
    store.reset()
  },

  dialogs: [
    {
      name: 'Invoice Preview',
      component: () => import('./dialogs/InvoicePreviewDialog'),
      title: 'Invoice Details',
      height: 600,
      cancelButton: true
    }
  ]
}

export default InvoiceConversionRoute